export default {
  exec: (name, body, contentType) => {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf])
    const blob = new Blob([bom, body], {type: contentType})
    const link = document.createElement("a")
    link.href = window.URL.createObjectURL(blob)
    link.download = name
    link.click()
  }
}
